<template lang="pug">
#benjamin-app.benjamin-app
  transition(name="animate" leave-active-class="animated slideOutUp" enter-active-class="animated slideInDown")
    top-nav(v-show="topNavVisible")
  //- the search form for desktop browsers
  search-form(context="desktop", v-bind:permanent="false")
  div#full-screen-content
    .main.benjamin-view
      router-view
    footer-nav
    #modal-contents.modal
      .modal-background
      .modal-content.content
        transcript-toc
      button.modal-close.is-large(aria-label="close" @click="closeModal")
    #modal-convolute.modal
      .modal-background
      .modal-content.content
        facsimile-bundle
      button.modal-close.is-large(aria-label="close" @click="closeModal")
</template>

<style lang="scss">
@import "./styles/index.scss";
</style>

<script>
import FacsimileBundle from "./components/FacsimileBundle";
import FooterNav from "./components/nav/FooterNav";
import SearchForm from "./components/search/SearchForm";
import SearchResults from "./components/search/SearchResults";
import TopNav from "./components/nav/TopNav";
import TranscriptToc from "./components/toc/TranscriptToc";

const { mapState } = require("vuex");

export default {
    name: "BenjaminApp",
    components: {
        FacsimileBundle,
        FooterNav,
        SearchForm,
        SearchResults,
        TopNav,
        TranscriptToc
    },
    data: () => ({
        topNavVisible: true,
        waypointOptions: {
            threshold: [...Array(200).keys()].map((v, i) => i / 200)
        }
    }),
    computed: {
        htmlclass () {
            var htmlclass = [];
            htmlclass.push( this.isHomepage ? 'is-home' : 'is-content' );
            htmlclass.push( this.$route.name ? this.$route.name : '' );
            return htmlclass.join(' ');
        },

        isHomepage: function() {
            return this.$route.name === "home"
        },

        ...mapState("i18n", ["locale"]),
        ...mapState("search", ["searchFormMessageBus"])
    },

    methods: {
        closeModal(evt) {
            const html = document.documentElement;
            const button = evt.target;
            const modals = document.querySelectorAll(".modal");

            html.classList.remove("is-clipped");
            button.classList.remove("is-active");

            modals.forEach((m) => {
                m.classList.remove("is-active");
            });
        }
    },

    mounted() {
        const html = document.documentElement;
        const footer = document.getElementById("footer");
        const store = this.$store;

        // fixed footer
        window.addEventListener("resize", () => {
            /* only fixed in desktop viewport */
            fixFooter(this, footer, html);
        });

        fixFooter(this, footer, html);
        html.classList.remove("setting-up");

        // detect preferred user languages, then set i18n accordingly
        const navigatorLanguage = navigator.language.substring(0,2);
        const availableLocales = new Set(["de", "en", "fr"]);
        const navigatorLanguages = navigator.languages ? navigator.languages : [];
        const preferredLanguages = navigatorLanguages.map(l => { return l.substring(0,2) }).reverse()
        const locale = preferredLanguages.reduce((acc, lang) => {
            if (availableLocales.has(lang)) {
                acc = lang;
            }
            return acc;
         }, navigatorLanguage);
         if (availableLocales.has(locale) && !store.state.i18n.localeSetByBrowserPreference) {
            store.commit("i18n/setLocale", locale)
            store.commit("i18n/setLocaleSetByBrowserPreference", true);
            this.$i18n.locale = locale;
         } else {
             // default locale is set in constructor of i18n via vuex store's default value
         }

         // key listener for modal close
         document.addEventListener("keyup", (evt) => {
            if (evt.key === "Escape" || evt.keyCode === 27) {
                document.querySelector(".modal-close").click(); // esc
            }
        });

    },

    watch: {
        htmlclass: (newValue, oldValue) => {
            const newValues = newValue.split(" ");
            const oldValues = oldValue.split(" ");

            const html = document.documentElement;
            oldValues.forEach(v => {
                if (v) {
                    html.classList.remove(v);
                }
            });
            newValues.forEach(v => {
                if (v) {
                    html.classList.add(v);
                }
            });        
        },

        locale(newValue) {
            this.$i18n.locale = newValue;
        }
    }
}

function fixFooter(vueModel, footer, html) {
    if(footer.classList.contains("is-fixed") || vueModel.$route.name=="translation") {
      // console.log("ADDING has-footer-fixed");
      var footerHeight=footer.offsetHeight;
      html.style["padding-bottom"]=footerHeight+"px";
      html.classList.add("has-footer-fixed");
    } else {
      // console.log("REMOVING has-footer-fixed");
      html.style["padding-bottom"]=0;
      html.classList.remove("has-footer-fixed");
    }
}
</script>